export default __webpack_public_path__ + "static/prong-collars-1-72d9f498b1daaf155e039b7ffc1dc20a.gif";